export const UNSPLASH_ACCESS_KEY =
  "C5QENfSRlHa4vsdqhgSBEEO1mI-IuKbA8H0EdyndSt4";
export const API_BASE = "/api/v1";

/** Dev: execute-api via setupProxy pathRewrite; prod: same relative path on ingress. */
export const API_GATEWAY_BASE = "/api/v1";
